<template>
    <div>
    <v-card
        class="mx-auto mt-4"
        max-width="95%"
        elevation="2"
    >
    <v-toolbar
        :class="{ 'cms-toolbar--alert': isMailAll }"
        dark
    >
    <v-toolbar-title>{{MailType_Text}}</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-switch
        v-model="isMailAll"
        label="전체 / 타겟"
        inset
        hide-details
    ></v-switch>
    </v-toolbar>

    
    <v-list>
        <!-- 유저 아이디  -->
        <v-list-item v-if="!isMailAll">
        <span style="width:160px"><v-card-title class="font-weight-bold">타겟 유저</v-card-title></span>        
        <span v-if="!is_Target_Multi">
        <v-text-field
            label="유저 아이디 입력"
            v-model="targetUser"
            value=""            
        ></v-text-field> 
        </span>
        <!-- <v-file-input
            label="아이템을 받을 유저리스트를 csv로 올려주세요"
            v-model="inputFile"
            @change="(file) => onFileChange(file)"
        ></v-file-input>  -->
        </v-list-item>      
        <v-divider/>                     
        <!-- 우편 제목 : 기본값 설정 별도로 할 수 있다.  -->
        <v-list-item>
        <span style="width:160px"><v-card-title class="font-weight-bold">메일 제목</v-card-title></span>
        <v-text-field
            label="메일 발송 제목"
            v-model="mailTitle"
            value=""            
        ></v-text-field> 

        </v-list-item>       

        <!-- 메시지 : 기본값 설정 별도로 할 수 있다. -->
        <v-divider/>
        <v-list-item>
        <span style="width:160px"><v-card-title class="font-weight-bold">메시지</v-card-title></span>
        <v-textarea
            filled
            v-model="mailMessage"
            name="input-7-4"
            label="메시지를 입력하세요."
            value=""
        ></v-textarea>
        </v-list-item>       
        <!-- 수령 가능 기간 -->
        <v-divider/>     
        <v-list-item>
        <span style="width:140px"><v-card-title class="font-weight-bold">날짜 선택</v-card-title></span>        
        <!-- ====================== 시작 날짜를 지정합니다 ====================== -->
        <!-- <v-col cols="12" lg="6"> -->
        <span style="width:120px" class="mr-3">
        <v-menu
            v-model="date_picker_1"
            :close-on-content-click="false"
            max-width="290"
        >
        <template v-slot:activator="{ on, attrs }">
            <v-text-field
                :value="computedDateFormattedMomentjs_begin"
                clearable
                label="시작날짜"
                readonly
                v-bind="attrs"
                v-on="on"
                @click:clear="date_begin = null"
                style="max-width: 120px;"
            ></v-text-field>
        </template>
        <v-date-picker
            v-model="date_begin"
            @change="date_picker_1 = false"
        ></v-date-picker>
        </v-menu>
        </span>
        <span style="width:120px" class="mr-3">
                            <v-menu
                                ref="menut1"
                                v-model="menut1"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                :return-value.sync="time1"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="290px"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="time1"
                                    label="시작 시간"
                                    prepend-icon="mdi-clock-time-four-outline"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                                </template>
                                <v-time-picker
                                v-if="menut1"
                                v-model="time1"
                                full-width
                                :use-seconds="true"
                                @click:second="$refs.menut1.save(time1)"
                                ></v-time-picker>
                            </v-menu>
        </span>
    <span class="mr-3">
    ~~~~~~ 
    </span>
    <span style="width:120px" class="mr-3">
        <v-menu
            v-model="date_picker_2"
            :close-on-content-click="false"
            max-width="290"
        >
        <template v-slot:activator="{ on, attrs }">
            <v-text-field
                :value="computedDateFormattedMomentjs_end"
                clearable
                label="종료날짜 (디폴트는 한달 뒤)"
                readonly
                v-bind="attrs"
                v-on="on"
                @click:clear="date_end = null"
            ></v-text-field>
        </template>
        <v-date-picker
            v-model="date_end"
            @change="date_picker_2 = false"
        ></v-date-picker>
        </v-menu>
        </span>
        <span style="width:120px">
                            <v-menu
                                ref="menut2"
                                v-model="menut2"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                :return-value.sync="time2"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="290px"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="time2"
                                    label="종료 시간"
                                    prepend-icon="mdi-clock-time-four-outline"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                                </template>
                                <v-time-picker
                                v-if="menut2"
                                v-model="time2"
                                full-width
                                :use-seconds="true"
                                @click:second="$refs.menut2.save(time2)"
                                ></v-time-picker>
                            </v-menu>
        </span>
        <span>
        {{ computedDuration }}
        
        </span>
        </v-list-item>
        <!-- <v-list-item>
        <div class="py-3"></div>
        <span style="width:160px"><v-card-title style="font-weight:bold">아이템 타입</v-card-title></span>
        <span style="width:540px" >        
        <v-radio-group
        v-model="select_item_type"
        @change="onChangeItemType"
        row
        >
        <v-radio
            label="결제 아이템 상품"
            value="type_purchase"
        ></v-radio>
        <v-radio
            label="일반 아이템"
            value="type_item"
            ></v-radio>
        </v-radio-group>
        </span>
        </v-list-item> -->
        <!-- 지급 상품  -->
        <v-divider/>
        <template v-for="(item, index) in selected_itemList">
        <v-list-item  :key="index">
        <span style="width:160px"><v-card-title class="font-weight-bold">아이템 {{index + 1}}</v-card-title></span>
        <span style="width:120px" >        
        <v-select
        v-model="selected_itemList[index]"
            :items="current_reward_list"
            item-text="name"
            item-value="key"
            label="타입설정"
            @change="Refresh_ItemInfo"
            outlined
            hide-details
        ></v-select>
        </span>
        <span style="width:20px"/>
        <span v-if="IsDetailKey_List(selected_itemList[index])">
            <v-select
                v-model="selected_itemList_detail[index]"
                :items="GetDetailKeyModel(selected_itemList[index])"
                item-text="name"
                item-value="key"
                label="상세 타입"
                @change="Refresh_ItemInfo"
                outlined
                hide-details
            ></v-select>
        </span>
        <span v-else-if="(!IsDetailKey_List(selected_itemList[index]) && IsContainDetailKey(selected_itemList[index]))">
            <v-text-field
            label="상세 타입(작성형)"
            v-model="selected_itemList_detail[index]"
            value=""            
        ></v-text-field> 
        </span>
        <span style="width:20px"/>
        <span style="width:140px">
        <v-text-field
            label="획득량/h(기본:1)"
            v-model="selected_itemList_count[index]"
            value=""            
            type="number"
        ></v-text-field> 
        </span>
        <div style="width: 10px;"></div>
        <span style="width:120px">
        <v-text-field
            label="유지시간 (Sec)"
            v-model="selected_itemList_duration[index]"
            value=""            
            type="number"
        ></v-text-field> 
        </span>
        <div style="width: 10px;"></div>
        <span style="width:80px">
             <v-btn width="80px"  style="background-color: #b9fbc0; color: black;"  @click="Select_ItemSetTime(index ,86400)">하루</v-btn>
        </span>
         <div style="width: 10px;"></div>
        <span style="width:80px">
             <v-btn width="80px"  style="background-color: #6be585; color: black;"   @click="Select_ItemSetTime(index ,604800)">일주일</v-btn>
        </span>
         <div style="width: 10px;"></div>
        <span style="width:80px">
             <v-btn width="80px"  style="background-color: #2ecc71; color: black;"  @click="Select_ItemSetTime(index ,2592000)">한달</v-btn>
        </span>

        <span style="width:20px"/>        
        <span v-if="(selected_itemList.length -1 ) != index">        
            <v-btn 
            elevation="2"
            icon
            outlined
            @click=OnRemoveItem(index)
            >
                <v-icon dark>
                mdi-close
                </v-icon>
            </v-btn>
        </span>
        <v-spacer/>
        </v-list-item>   
        </template> 
        <v-divider class="mt-4"/>
        <v-divider/>

        <v-list-item>
            <v-spacer></v-spacer>
            <v-btn width="120px"  color="lime accent-3"  @click="OnRegist_Mail">등록하기</v-btn>
            <v-spacer></v-spacer>
        </v-list-item>       
        <!-- 지급 상품  -->
        <!-- 유효 기간  -->
        <!-- 등록 하기  -->



    </v-list>
    </v-card>
    
    <v-card
        class="mx-auto mt-4"
        max-width="95%"
        elevation="2"
    >
    <v-toolbar
        :color="'grey darken-1'"
        dark
    >
    <v-toolbar-title>메일 발송 이력</v-toolbar-title>
    </v-toolbar>
    <v-list>
        <v-data-table         
        :footer-props="{'items-per-page-options':[20, 50, -1]}"
        :headers="headers" 
        :items="mail_history_all"
        :loading="loadingData"
        >        
        <template v-slot:item="row">            
            <tr>
            <td>{{row.item.MAIL_NO}}</td>
            <td>{{row.item.MAIL_INFO.title}}</td>
            <td>{{row.item._USER_ID}}</td>
            <td>{{row.item.CREATE_DT}}</td>
            <td>{{row.item.EXPIRE_START_DT + "~"+row.item.EXPIRE_END_DT}}</td>
            <td>{{row.item.USER_ID}}</td>
            
            <!-- <td>
                <v-switch
                    :v-model="`${IsActiveState(row.item)}`"
                    label=""
                    inset                    
                ></v-switch>
            </td> -->
            </tr>
        </template>
        </v-data-table>
    </v-list>
    </v-card>
    <div class='py-12'/>
    <div class='py-12'/>
    </div>   
    
</template>

<script>
const xlsx = require( "xlsx" );
//import xlsx = from 'xlsx';
import { mapActions } from 'vuex';
import moment from 'moment'
import store from '../../store';
import config from '../../config/config';
import { format, parseISO } from 'date-fns'
export default {
    name: 'UserList',

    data: () => ({
        
        menut1: false,
        menut2:false,
        time:"",
        time1:"00:00:00",
        time2:"23:59:59",
        targetUser:'',
        isMailAll:false,
        loadingData:false,        
        mailTitle:'',
        mailMessage:'',
        date_begin: format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
        date_end:format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
        date_picker_1: false,
        date_picker_2: false,
        selected_user_container:[],

        itemInfoList:[
            // {
            //     name:'채굴기',
            //     key:'1000001',
            // },
            {
                name:'나무',
                key:'1000002',
                detail_keys:[{name:'건강한나무',key:'2000000'}]
            }            
        ],
        selected_itemList:[],   ///인덱스만 담기것지 나중에 전송할때는 한번 가공하도록 한다         
        selected_itemList_detail:[],
        selected_itemList_count:[],
        selected_itemList_duration:[],
        title_type_items:[],    //타이틀 설정 하도록 
        headers: [            
            { text: '고유번호', value: 'mail_no' },
            { text: '메일 제목', value: 'title' },
            { text: '관리자', value: 'admin' },
            { text: '등록일자', value: 'regist_date' },
            { text: '수령기간', value: 'get_date' },
            { text: '타겟', value: 'target' },            
        ],
        mail_history_all:[
        ],
        select_item_type:"default_item",        
        current_reward_list:[],
        inputFile:null,
    }),

    created()
    {
        this.date_end = moment().add(1,'M').format('yyyy-MM-DD');
        this.LoadServerInfo();
        this.LoadRecentMailInfo();
        this.Refresh_ItemInfo();
        let queryData = this.$route.query;
        if(queryData.USER_ID != undefined)
        {
            this.targetUser = queryData.USER_ID;
        }
      
    },

    methods:{
        ...mapActions([
            'QUIZANDCASH_GET_MAIL_LIST_RECENT',
            'QUIZANDCASH_CREATE_MAIL',            
            'QUIZANDCASH_GET_MAIL_USERINFO_LIST_NICK',
            'QUIZANDCASH_CREATE_MAIL_MULTI'
        ]),

        onChangeItemType(val)
        {            
            this.select_item_type = val;
            this.selected_itemList = [];
            this.selected_itemList_detail = [];
            this.selected_itemList_count = [];
            this.Refresh_ItemInfo();
            // if(this.select_item_type == "type_purchase")
            // {
            //     this.current_reward_list = this.purchaseInfoList;
            // }
            // else
            // {
                
            // }
            this.current_reward_list = this.itemInfoList;
            console.log(this.select_item_type);
            
            console.log(JSON.stringify(this.current_reward_list));
            //alert(this.select_item_type);
        },
        
        LoadServerInfo(){   
            fetch(this.serverState_URL)
                    .then(response => response.json())
                    .then(data => {
                        console.log("JSJS :  "+JSON.stringify(data));
                        //this.mail_template = data.server_state.SERVICE_OPTION.item_opt;
                        //this.itemInfoList = data.server_state.SERVICE_OPTION.item_opt;
                        //this.mailTitle = data.server_state.SERVICE_OPTION.mail_title; 
                        //this.mailMessage = data.server_state.SERVICE_OPTION.mail_message; 
                        this.mailTitle = "이벤트보상";
                        this.mailMessage = "이벤트 보상이 지급 되었습니다.";
                        this.current_reward_list = this.itemInfoList;         
                        console.log("LoadServerInfo :  "+JSON.stringify(this.itemInfoList));
                        //this.purchaseInfoList =body_data.server_state.SERVICE_OPTION.purchase_opt;
                    })
                    .catch(error => {
                        console.error('Error fetching server state:', error);
                    });
        },

        LoadRecentMailInfo(){
            //let packageName = this.$store.state.selected_game_package;
            //let server_index = this.$store.state.selected_game_server;
            this.QUIZANDCASH_GET_MAIL_LIST_RECENT({}).then((body_data)=>{
                this.mail_history_all = body_data.recent_mail_list;
            })
            .catch((err) => {
                this.error = err;
                console.log(err);
            })

        },

        OnClickUserInfo(_item)
        {
            this.loadingData = true;
            alert(_item.user_id + "의 정보를 확인합니다.");
            //let locateValue  = location.protocol +  "//"+location.host+'/story_eventedit?seq_event_new='+selectItem.seq_event_new;
            //window.location.href = locateValue;
        },
        OnClickUser_Mail(_item)
        {
            this.loadingData = false;
            alert(_item.user_id + "에게 메일을 보내려고합니다.");
        },
        IsActiveState(_item)
        {
            return _item.active_yn=="Y"?true:false;
        },
        OnRegist_Mail()
        {
            //alert('우편을 등록하려 합니다. 내용 확인 ㅇㅈ?');
            if(!this.isMailAll)
            {
                if(this.targetUser == '' && this.selected_user_container.length == 0)
                {
                    alert('타겟 유저발송은 유저아이디를 입력해야합니다.');
                    return;
                }
            }
            this.Make_ItemResultInfo();
            let packageName = this.$store.state.selected_game_package;
            let mailData = '';
            let reward_item = this.Make_ItemResultInfo();
            // 이쪽에 시간을 그냥 임이의 시간을 넣어주는 것이 아닌 시간을 지정하여서 넣어준다.2021-11-10 23:59:00
            let expire_start =   this.date_begin + ' ' + this.time1;
            let expire_end =   this.date_end + ' ' + this.time2;
            let mail_type = this.isMailAll ?'all':'single';
            let user_id = this.targetUser;
            let mail_info = {};
            mail_info.item = reward_item;
            mail_info.title = this.mailTitle;
            mail_info.message = this.mailMessage;
            if(reward_item.length == 0)
            {
                alert("지정된 아이템 없음");
                return;
            }


            if(this.isMailAll)
            {
                user_id = 'ALL';
                if(this.select_item_type == "type_purchase")
                {
                    alert("결제상품은 전체보내기로 등록할 수 없습니다.");
                    return;
                }
            }
            else
            {
                if(this.select_item_type == "type_purchase")
                {
                    mail_type = 'CSP';
                    mail_info.title = '결제상품';
                    mail_info.message = '결제상품';
                    let create_item_result = this.Make_ItemResultInfo_Purchase();
                    //Object.keys(dictionary).length
                    let result_item_count = Object.keys(create_item_result);
                    console.log(">>>>>>>>>>>> "+result_item_count);
                    if(result_item_count == 0)
                    {
                        alert("지정된 아이템 없음");
                    }                
                    mail_info = create_item_result;
                }      
            }
                

            if(!this.isMailAll && this.selected_user_container.length > 0)
            {
                let user_list = this.selected_user_container;
                let server_index = this.$store.state.selected_game_server;

                this.QUIZANDCASH_CREATE_MAIL_MULTI({user_list, mail_info,expire_start, expire_end , server_index}).then((body_data)=>{
                    console.log("CREATE_MAIL_MULTI"+JSON.stringify(body_data));
                    this.mail_history_all = body_data.recent_mail_list;
                    this.LoadRecentMailInfo();
                    alert(`${JSON.stringify(body_data.count)} 명 전송완료`);
                    this.selected_user_container= [];
                    this.inputFile = null;
                    //console.log(body_data.server_state.SERVICE_OPTION.item_opt);
                    //this.itemInfoList = body_data.server_state.SERVICE_OPTION.item_opt;
                })
                .catch((err) => {
                    this.error = err;
                    console.log(err);
                })
            }
            else{
                let server_index = this.$store.state.selected_game_server;
                this.QUIZANDCASH_CREATE_MAIL({mail_type , user_id , mail_info,expire_start, expire_end,server_index}).then((body_data)=>{
                    console.log("CREATE_MAIL"+JSON.stringify(body_data));
                    this.mail_history_all = body_data.recent_mail_list;
                    this.LoadRecentMailInfo();
                    alert("완료!");
                    //console.log(body_data.server_state.SERVICE_OPTION.item_opt);
                    //this.itemInfoList = body_data.server_state.SERVICE_OPTION.item_opt;
                })
                .catch((err) => {
                    this.error = err;
                    console.log(err);
                })
            }



       



        },
        Refresh_ItemInfo()
        {//등록된 아이템 정보 + 1
            let tempContainer1 = [];
            let tempContainer2 = [];
            let tempContainer3 = [];
            
            for(let index=0; index < this.selected_itemList.length; index++)
            {
                let item1 = this.selected_itemList[index];
                if(item1!= null)
                {
                    tempContainer1.push(item1);
                    let item2 = this.selected_itemList_count[index];
                    tempContainer2.push(item2 == undefined?0:item2);
                    let item3 = this.selected_itemList_duration[index];                                
                    tempContainer3.push(item3??(24*3600)); //기본값은 24시간으로 설정한다.
                }
            }
            this.selected_itemList= [];
            this.selected_itemList_count= [];
            this.selected_itemList_duration= [];

            for(let index=0; index < tempContainer1.length; index++)
            {
                let item1 = tempContainer1[index];
                if(item1!= null)
                {
                    this.selected_itemList.push(item1);
                    this.selected_itemList_count.push(tempContainer2[index]);
                    this.selected_itemList_duration.push(tempContainer3[index]);

                }
            }
            console.log("Refresh_ItemInfo : " + this.select_item_type)   ;
            if(this.select_item_type != "type_purchase" || this.selected_itemList.length == 0)
            {                
                this.selected_itemList.length = tempContainer1.length + 1;
                this.selected_itemList_count.length = tempContainer1.length + 1;
                this.selected_itemList_duration.length = tempContainer1.length + 1;
            }
        },
        OnRemoveItem(_index)
        {
            this.selected_itemList[_index] = undefined;
            this.Refresh_ItemInfo();
        },
        IsContainDetailKey(_itemKey)
        {
            if(_itemKey == undefined)
                return; 
            for(let index = 0; index < this.itemInfoList.length ; index++)
            {
                let item = this.itemInfoList[index];
                if(item.key == _itemKey)
                {

                    const isExist = Object.keys(item).includes('detail_keys')
                        return isExist;
                }
                    
            }
            return false;
        },
        IsDetailKey_List(_itemKey)
        {
            if(_itemKey == undefined)
                return false; 
            for(let index = 0; index < this.itemInfoList.length ; index++)
            {
                let item = this.itemInfoList[index];
                if(item.key == _itemKey)
                {
                    const isExist = Object.keys(item).includes('detail_keys')
                    if(isExist)
                    {
                        if(item.detail_keys.length > 0)
                            return true;
                        else
                            return false;
                    }
                }
                    
            }
            return false;
        },
        GetDetailKeyModel(_selectedItem)
        {
            for(let index = 0; index < this.itemInfoList.length ; index++)
            {
                let item = this.itemInfoList[index];
                if(item.key == _selectedItem)
                    return item.detail_keys;
            }
            return {};
        },
        Make_ItemResultInfo()
        {
            let resultValue=[];
         
            for(let index = 0; index < this.selected_itemList.length ; index++)
            {
                let itemInfo = {};
                if(this.selected_itemList[index] != undefined)
                {
                    itemInfo['key'] = this.selected_itemList[index];
                    itemInfo['count'] = this.selected_itemList_count[index];
                    itemInfo['duration'] = this.selected_itemList_duration[index];
                    
                    if(this.selected_itemList_detail[index] != undefined)
                        itemInfo['detail_key'] = this.selected_itemList_detail[index];
                    // else
                    //     itemInfo['detail_key'] = '';
                    resultValue.push(itemInfo);
                }
            }
            return resultValue;
        },
        Make_ItemResultInfo_Purchase()
        {
            let resultValue={};            
            let key_value = this.selected_itemList[0];
            if(this.selected_itemList[0] != undefined)
            {
                resultValue['key'] =key_value;
                resultValue['name'] = key_value;
                resultValue['quantity'] = 1;
            }
            return resultValue;
        },
        add_multiple_userId(user_info)
        {   
            console.log(user_info);
        },
        onFileChange(file) {
            if(file != null)
            {
            var reader = new FileReader();
            let packageName = this.$store.state.selected_game_package;
            reader.onload = (e)=>
            {
                //var textData = reader.result;                             
                //console.log("ON READER LOAD : "+textData);   
                //console.log("JS : " + sheetName);
                this.selected_user_container = [];
                let nickContainer = [];
                let tempContainer  = [];
                let data = reader.result;
                let workBook = xlsx.read(data, { type: 'binary' });
                //this.add_multiple_userId("test");
                //Sheet1
                let sheetName = "Sheet1";
                let rows = xlsx.utils.sheet_to_json(workBook.Sheets[sheetName]);
                for(let index =0;  index < rows.length ; index++)
                {
                    let row = rows[index];
                    console.log(row);
                    if(row["USER_ID"] == undefined)
                    {///유저아이디가 없다 
                        if(row["NICK"] != undefined)
                        {
                            nickContainer.push(row["NICK"]);
                        }
                    }
                    else{
                        this.selected_user_container.push(row["USER_ID"]);
                    }
                }
                
                //console.log(JSON.stringify(this.selected_user_container));
                this.Check_ValidateUserNick(nickContainer, (_result)=>{
                    console.log("Check_ValidateUserNick : " + _result);
                    let errorMessage = "";
                    _result.user_list.forEach((item) => {
                        console.log(JSON.stringify(item));
                        if(item["USER_ID"] == undefined)
                        {
                            errorMessage += " "
                            errorMessage += item["NICK"];
                            errorMessage += " , "
                        }
                        else{
                            this.selected_user_container.push(item["USER_ID"]);
                        }
                    });
                    if(errorMessage == "")
                    {
                        alert("닉네임 검증완료!");
                    }
                    else
                    {
                        errorMessage += "\n 일부유저 닉네임이 확인되지 않습니다.";
                        alert(errorMessage);
                        this.selected_user_container = [];//비워준다 
                        this.inputFile = null;
                    }

                });
                //테이블내의 닉네임만 입력된 애들을 검증한다 
                //this.CREATE_MAIL({packageName , mail_type , user_id , mail_info,expire_start, expire_end}          
            }
            reader.readAsBinaryString(this.inputFile);
            }
         
        },
        Check_ValidateUserNick(nicklist , result_action)
        {
            let packageName = this.$store.state.selected_game_package;
            let server_index = this.$store.state.selected_game_server;
            console.log("JS: "+ JSON.stringify(nicklist));
            this.QUIZANDCASH_GET_MAIL_USERINFO_LIST_NICK({packageName , nicklist , server_index}).then((body_data)=>{
                //this.mail_history_all = body_data.recent_mail_list;
                console.log("닉네임 리스트를 체크합니다 " + body_data);
                result_action(body_data);
            })
            .catch((err) => {
                this.error = err;
                console.log(err);
            })
        },
        Select_ItemSetTime(index , time){
            //this.selected_itemList_duration[index]  = time;
            this.$set(this.selected_itemList_duration, index, time);    
            //this.$set(this.selected_itemList_duration, index, time); // 하루
        }
    },
    computed: {
        serverState_URL () {
            return config.serverState_URL_QUIZ_N_CASH;
        },
        isLive(){
            return config.isLive;
        },
        is_Target_Multi()
        {
            if(this.selected_user_container.length == 0)
                return false;
            else 
                return true;
        },
        MailType_Text()
        {
            if(this.isMailAll)
                return "[전체메일 발송] - 신중하게 작성 요망.";
            else
                return "[타겟유저 발송] - 유저의 아이디가 필수입니다.";
        },
        MailType_TabColor()
        {
            if(this.isMailAll)
                return "red accent-4";
            else
                return "light-blue darken-3";
        },   
        computedDateFormattedMomentjs_begin () {
            return this.date_begin ? moment(this.date_begin).format('YYYY-MM-DD') : ''
        },
        computedDateFormattedMomentjs_end () {
            return this.date_end ? moment(this.date_end).format('YYYY-MM-DD') : ''
        },
        computedDuration() {
            if (!this.date_begin || !this.time1 || !this.date_end || !this.time2) {
                return "(날짜 입력 필요)";
            }

            const startDateTime = moment(`${this.date_begin} ${this.time1}`, 'YYYY-MM-DD HH:mm:ss');
            const endDateTime = moment(`${this.date_end} ${this.time2}`, 'YYYY-MM-DD HH:mm:ss');

            if (!startDateTime.isValid() || !endDateTime.isValid()) {
                return "(잘못된 날짜)";
            }

            const duration = moment.duration(endDateTime.diff(startDateTime));
            const days = Math.floor(duration.asDays());
            const hours = duration.hours();
            const minutes = duration.minutes();

            return `(${days}일 ${hours}시간 ${minutes}분)`;
        }    
    },
    components:{
    },
    watch :{
        '$store.state.selected_game_package': function() {
            console.log("WHAT IS THIS? " + this.$store.state.selected_game_package)
            this.LoadServerInfo();
            this.LoadRecentMailInfo();
            this.selected_itemList = [];
            this.selected_itemList_detail = [];
            this.selected_itemList_count = [];
            this.selected_itemList_duration = [];
            this.Refresh_ItemInfo();
        },
        '$store.state.selected_game_server': function() {
            console.log("WHAT IS THIS? " + this.$store.state.selected_game_package)
            this.LoadServerInfo();
            this.LoadRecentMailInfo();
            this.selected_itemList = [];
            this.selected_itemList_detail = [];
            this.selected_itemList_count = [];
            this.selected_itemList_duration = [];
            this.Refresh_ItemInfo();
        },



        select_item_type:function()
        {
         //   alert("test");
        }
    }
};
</script>
<style scoped>
@media (max-width: 600px) {
  .v-list-item {
    flex-wrap: wrap;
  }
  .v-list-item > span {
    width: 100% !important;
  }
  .v-list-item > div {
    width: 100% !important;
  }
  .v-list-item .v-card__title {
    padding: 8px 0;
  }
  .v-data-table {
    overflow-x: auto;
  }
  .v-toolbar__content {
    flex-wrap: wrap;
    height: auto !important;
    padding: 8px;
    gap: 4px;
  }
}
</style>
